import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { loadAllProfessors } from "../../lib/api/professor";
import { ProfessorHomeForm } from "../../components/professor/ProfessorHomeForm";

const Home = () => {
  const navigate = useNavigate();

  const [professors, setProfessors] = useState();

  const requestLoadAllProfessors = useCallback(async () => {
    const { data } = await loadAllProfessors();
    setProfessors(data);
    //console.log(data);
  }, []);

  useEffect(() => {
    requestLoadAllProfessors();
  }, [requestLoadAllProfessors]);

  const handleDetail = (e) => {
    const id = e.target.value;
    navigate(`/professors/${id}`);
  };

  return (
    <div>
      <Container fluid="md">
        <ProfessorHomeForm
          professors={professors}
          handleDetail={handleDetail}
        />
      </Container>
    </div>
  );
};

export default Home;
